import React from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { useHistory, useLocation, useParams } from "react-router-dom";

import messages from "../../../assets/locale/messages";
import { UIButton, UIIcon } from "../../ui";
import { formatDate } from "../../../utils/Helpers";
import { ROUTE_PATHS } from "../../../utils/RoutesPaths";

import "./_CompanyEditRequestBanner.scss";

const WARNING_ICON_COLOR = "var(--color-warning-default, #F59E0B)";

const CompanyEditRequestBanner = ({ isReviewRequestOpen, submittedAt }) => {
  const lang = useSelector((state) => state.locale.lang);
  const { companiesList: cl } = messages[lang];
  const { id } = useParams();
  const history = useHistory();
  const location = useLocation();

  const handleReviewRequest = () => {
    history.push(ROUTE_PATHS.reviewProfileUpdateRequest.replace(":id", id), {
      // Carries "came from Profile Edit Requests" forward so that page's
      // breadcrumb (and post-decision redirect) stays correct too.
      fromProfileEditRequests: Boolean(
        location.state?.fromProfileEditRequests,
      ),
    });
  };

  return (
    <div className="company-edit-request-banner">
      <div className="company-edit-request-banner__lead">
        <UIIcon
          name="alertCircle"
          width={38}
          height={38}
          color={WARNING_ICON_COLOR}
          strokeWidth={3.11}
          decorative
          className="company-edit-request-banner__icon"
        />

        <div className="company-edit-request-banner__content">
          <p className="company-edit-request-banner__title">
            {isReviewRequestOpen
              ? cl.pendingProfileUpdateRequest
              : cl.pendingProfileRequest}
          </p>
          {isReviewRequestOpen && submittedAt && (
            <p className="company-edit-request-banner__date">
              {cl.submittedOn.replace("{date}", formatDate(submittedAt))}
            </p>
          )}
        </div>
      </div>

      {!isReviewRequestOpen && (
        <UIButton
          type="button"
          variant="link"
          size="small"
          className="company-edit-request-banner__button"
          onClick={handleReviewRequest}
        >
          {cl.reviewRequest}
        </UIButton>
      )}
    </div>
  );
};

export default CompanyEditRequestBanner;

CompanyEditRequestBanner.propTypes = {
  isReviewRequestOpen: PropTypes.bool,
  submittedAt: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.instanceOf(Date),
  ]),
};

CompanyEditRequestBanner.defaultProps = {
  isReviewRequestOpen: false,
  submittedAt: undefined,
};
